import { useState, useEffect } from 'react';
// import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import dayjs from 'dayjs';


// import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
// import UpcomingIcon from '@mui/icons-material/Upcoming';
// import FactCheckIcon from '@mui/icons-material/FactCheck';
import { GreenSwitch, TextUnderlineHeading } from '../../Styles';
import { OpenSwal } from '../../Utils';
import { useNavigate } from 'react-router-dom';
import { LoadingButton } from '@mui/lab';
import { FormControlLabel } from '@mui/material';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import { AssignmentsStatusList } from './AssignmentsListscard';
import LinearProgress from '@mui/material/LinearProgress';
import { url_fetch_assignment_lists } from '../../RoutesMap';
import { apiWithAuth } from '../../Services/Axios/axios';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { url_view_bill_pdf_generation } from '../../RoutesMap';

function InvoiceStatusCard({ invoice, appThemeColor }) {
const [pdfOpen, setPdfOpen] = useState(false);
const [invoiceHtml, setInvoiceHtml] = useState('');
const [invoiceLoading, setInvoiceLoading] = useState(false);
const handleViewInvoice = async () => {
    setPdfOpen(true);
    setInvoiceLoading(true);
    setInvoiceHtml('');

    const payload = new FormData();
    payload.append('inv_id', invoice.invoice_pid);
    payload.append('status', 'view');

    try {
        const response = await apiWithAuth.post(
            url_view_bill_pdf_generation,
            payload,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                timeout: 60000
            }
        );

        const result = response.data;

        // The backend returns HTML directly for status = "view".
        const html =
            typeof result === 'string'
                ? result
                : typeof result?.data === 'string'
                    ? result.data
                    : '';

        if (!html) {
            throw new Error('Invoice HTML was not returned.');
        }

        setInvoiceHtml(html);
    } catch (error) {
        console.error('Error viewing invoice:', error);
        setInvoiceHtml('');
        setPdfOpen(false);
    } finally {
        setInvoiceLoading(false);
    }
};



const [invoiceDownloading, setInvoiceDownloading] = useState(false);

const handleDownloadInvoice = async () => {
    setInvoiceDownloading(true);

    const payload = new FormData();
    payload.append('inv_id', invoice.invoice_pid);
    payload.append('status', 'pdf');
    payload.append(
        'pdfname',
         String(invoice.invoice_id || invoice.invoice_pid)
    );

    try {
        const response = await apiWithAuth.post(
            url_view_bill_pdf_generation,
            payload,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        );

    //     const result = response.data;

    //     if (!result || result.status !== true || !result.file_blob) {
    //         console.error('Invoice download response:', result);
    //         throw new Error(
    //             result?.message || 'Invoice PDF was not generated.'
    //         );
    //     }

    //     const link = document.createElement('a');
    //     link.href = result.file_blob;
    //     link.download =
    //         result.file_name ||
    //         `${invoice.invoice_id || invoice.invoice_pid}.pdf`;

    //     document.body.appendChild(link);
    //     link.click();
    //     link.remove();
    // } catch (error) {
    //     console.error('Error downloading invoice:', error);
    // } finally {
    //     setInvoiceDownloading(false);
    // }
    const result = response.data;

if (!result || result.status !== true || !result.file_blob) {
    console.error('Invoice download response:', result);
    throw new Error(
        result?.message || 'Invoice PDF was not generated.'
    );
}

const base64Data = result.file_blob.replace(
    /^data:application\/pdf;base64,/,
    ''
);

const byteCharacters = atob(base64Data);
const byteNumbers = new Uint8Array(byteCharacters.length);

for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
}

const blob = new Blob([byteNumbers], {
    type: 'application/pdf'
});

const url = window.URL.createObjectURL(blob);

const link = document.createElement('a');
link.href = url;
link.download =
    result.file_name ||
    `${invoice.invoice_id || invoice.invoice_pid}.pdf`;

document.body.appendChild(link);
link.click();
link.remove();

window.URL.revokeObjectURL(url);

} catch (error) {
    console.error('Error downloading invoice:', error);
} finally {
    setInvoiceDownloading(false);
}
};





    const status = String(invoice.invoice_status ?? '')
        .toLowerCase();

    const statusDetails = {
        pending: {
            label: 'Approval Pending',
            color: 'warning'
        },
        approved: {
            label: 'Approved',
            color: 'success'
        },
        paid: {
            label: 'Paid',
            color: 'info'
        }
    };

    const currentStatus = statusDetails[status] || {
        label: status || 'Unknown',
        color: 'default'
    };

    const actualAmount = invoice.actual_amount;
    const paidAmount = invoice.paid_amount;
    const assignmentCount = Number(invoice.no_assignment) || 0;

    const formatCurrency = (amount) => {
        if (
            amount === null ||
            amount === undefined ||
            amount === '' ||
            !Number.isFinite(Number(amount))
        ) {
            return '$0.00';
        }

        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
        }).format(Number(amount));
    };

    const assignmentIds = String(invoice.assignment_ids || '')
        .split(',')
        .map((id) => id)
        .filter(Boolean);

    const visibleIds = assignmentIds.slice(0, 3);
    const remainingIds = assignmentIds.slice(3);

    return (
        <Grid xs={12} sm={6} md={4}>
            <Card
                variant="outlined"
                sx={{
                    height: '100%',
                    minWidth: 0,
                    width: '100%',
                    borderRadius: '12px',
                    borderColor: '#e0e0e0',
                    boxSizing: 'border-box',
                    overflow: 'hidden'
                }}
            >
                <CardContent
                    sx={{
                        p: { xs: 2, sm: 2.5 },
                        '&:last-child': {
                            pb: { xs: 2, sm: 2.5 }
                        },
                        minWidth: 0,
                        overflowWrap: 'anywhere',
                        wordBreak: 'break-word'
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                            gap: 1,
                            mb: 2
                        }}
                    >
                        <Typography
                            variant="subtitle1"
                            sx={{
                                fontWeight: 'bold',
                                color: appThemeColor,
                                fontSize: { xs: '1.05rem', sm: '1.1rem' },
                                lineHeight: 1.5,
                                overflowWrap: 'anywhere',
                                wordBreak: 'break-word',
                                minWidth: 0,
                                flex: 1
                            }}
                        >
                            Invoice #{invoice.invoice_id || invoice.invoice_pid}
                        </Typography>

                        <Chip
                            label={currentStatus.label}
                            color={currentStatus.color}
                            size="small"
                            sx={{ flexShrink: 0 }}
                        />
                    </Box>

                    <Typography
                        variant="body2"
                        sx={{ mb: 1.5, lineHeight: 1.6 }}
                    >
                        Invoice Date: {invoice.date_time || 'N/A'}
                    </Typography>

                    <Typography
                        variant="body2"
                        sx={{
                            mb: 1.5,
                            lineHeight: 1.6,
                            overflowWrap: 'anywhere'
                        }}
                    >
                        Invoice Type: {invoice.invoice_type || 'N/A'}
                    </Typography>

                    <Typography
                        variant="body2"
                        sx={{ mb: 1.5, lineHeight: 1.6 }}
                    >
                        Assignment Count: <strong>{assignmentCount}</strong>
                    </Typography>

                    <Typography
                        variant="body2"
                        sx={{
                            mb: 2,
                            lineHeight: 1.8,
                            minWidth: 0,
                            overflowWrap: 'anywhere',
                            wordBreak: 'break-word'
                        }}
                    >
                        Assignment IDs:{' '}
                        <strong>
                            {visibleIds.join(', ') || 'N/A'}

                            {remainingIds.length > 0 && (
                                <Tooltip
                                    title={remainingIds.join(', ')}
                                    arrow
                                >
                                    <Box
                                        component="span"
                                        sx={{
                                            ml: 0.5,
                                            cursor: 'pointer',
                                            color: 'primary.main',
                                            textDecoration: 'underline'
                                        }}
                                    >
                                        +{remainingIds.length} more
                                    </Box>
                                </Tooltip>
                            )}
                        </strong>
                    </Typography>

                    <Typography
                        variant="body2"
                        sx={{
                            mt: 2,
                            mb: 1.5,
                            lineHeight: 1.7,
                            overflowWrap: 'anywhere'
                        }}
                    >
                        <strong>
                            Amount: {formatCurrency(actualAmount)}
                        </strong>
                    </Typography>

                    {/* <Typography
                        variant="body2"
                        sx={{
                            mb: 1,
                            lineHeight: 1.7,
                            overflowWrap: 'anywhere'
                        }}
                    >
                        <strong>
                            Paid Amount: {formatCurrency(paidAmount)}
                        </strong>
                    </Typography> */}

                    
<Box
    sx={{
        mt: 2,
        display: 'flex',
        flexWrap: 'wrap',
        gap: 1,
        justifyContent: 'flex-start'
    }}
>
    {/* <Button
        variant="contained"
        onClick={handleViewInvoice}
        disabled={invoiceLoading || invoiceDownloading}
        sx={{
            backgroundColor: appThemeColor,
            color: '#fff',
            textTransform: 'none',
            borderRadius: '8px',
            px: 3
        }}
    >
        {invoiceLoading ? 'Loading...' : 'View'}
    </Button> */}

    <Button
        variant="contained"
        onClick={handleDownloadInvoice}
        disabled={invoiceDownloading || invoiceLoading}
        sx={{
            backgroundColor: appThemeColor,
            color: '#fff',
            textTransform: 'none',
            borderRadius: '8px',
            px: 3
        }}
    >
        {invoiceDownloading ? 'Downloading...' : 'Download Invoice'}
    </Button>
</Box>

                </CardContent>
            </Card>

            <Dialog
                open={pdfOpen}
                onClose={() => setPdfOpen(false)}
                fullWidth
                maxWidth="lg"
                PaperProps={{
                    sx: {
                        height: { xs: '90vh', sm: '85vh' },
                        maxHeight: '90vh',
                        borderRadius: { xs: 2, sm: 3 }
                    }
                }}
            >
                <DialogTitle
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: 1
                    }}
                >
                    View Invoice

                    <IconButton
                        onClick={() => setPdfOpen(false)}
                        aria-label="Close invoice PDF"
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers sx={{ p: 0, overflow: 'hidden' }}>
    {invoiceLoading ? (
        <Box sx={{ p: 3 }}>Loading invoice...</Box>
    ) : (
        <Box
            component="iframe"
            title="Invoice Preview"
            srcDoc={invoiceHtml}
            sx={{
                width: '100%',
                height: '70vh',
                border: 0,
                display: 'block',
                backgroundColor: '#fff'
            }}
        />
    )}
</DialogContent>
            </Dialog>
        </Grid>
    );
}


function AssignmentLists({ assignStatus, PusherDashboardTrigger }) {
    const appThemeColor = "#" + process.env.REACT_APP_THEME_COLOR;
    const appThemeSecondaryColor = process.env.REACT_APP_THEME_SECONDARY_COLOR;
    const [newAssignmentRequestAry, newAssignmentRequestArySet] = useState([]);
    const [hasPastAssignments, setHasPastAssignments] = useState(false);
    const [viewNewAssignmentRequestButtonSpin, viewNewAssignmentRequestButtonSpinSet] = useState(false);
    const [DisableApplyLocalTime, DisableApplyLocalTimeSet] = useState(true);
    const [viewNewAssignmentRequestButton, viewNewAssignmentRequestButtonSet] = useState(null);
    const [axiosuseEffectstatus, axiosuseEffectstatuslimitset] = useState('limit');
    const [TriggerListLoadUseEffect, TriggerListLoadUseEffectSet] = useState('');
    const [invoiceStatusFilter, setInvoiceStatusFilter] = useState('pending');
    const [actionListFilter, setActionListFilter] = useState('submission');


    const Apply_local_time_statelocalstorage = localStorage.getItem('Apply_local_time_state');

    const [ApplyLocalTimeState, ApplyLocalTimeStateSet] = useState((Apply_local_time_statelocalstorage) ? true : false);
    const navigate = useNavigate();
    // console.log(assignStatus)
    let assignstatusHeading = "";
    if (assignStatus === "inprogress") {
        assignstatusHeading = "New Assignment Request";
    } else if (assignStatus === "upcoming") {
        assignstatusHeading = "Upcoming Assignments";
    } else if (assignStatus === "active") {
        assignstatusHeading = "Active Assignments";
    } else if (assignStatus === "lapsed") {
        assignstatusHeading = "Voucher Upload Req’d";
    } else if (assignStatus === "completed") {
        assignstatusHeading = "Completed Assignments";
    } else if (assignStatus === "cancelled") {
        assignstatusHeading = "Cancelled Assignments";
    } else if (assignStatus === "withdrawn") {
        assignstatusHeading = "Withdrawn Assignments";
    } else if (assignStatus === "verification") {
        assignstatusHeading = "Service Info - Verification Pending Assignments";
    }else if (assignStatus === "action") {
        assignstatusHeading = "Service Info - Action Required";
    } else if (assignStatus === "billed") {
        assignstatusHeading = "Billed Assignments";
    } else if (assignStatus === "invoicing") {
        assignstatusHeading = "Invoice History";
    }

    const cardTheme = ({  //white theme
        colors: {
            text: '#ffffff',
            main: '#f2f2f2',
            dark: '#f2f2f2',
            contrastText: '#03070f',
        },
        cardborderRadius: '15px'
    });



    useEffect(() => {
        DisableApplyLocalTimeSet(true);
        loadAssignmentList();
    }, [TriggerListLoadUseEffect]);

    useEffect(() => {
        newAssignmentRequestArySet([]);
        viewNewAssignmentRequestButtonSet(null);
        axiosuseEffectstatuslimitset('limit');
        viewNewAssignmentRequestButtonSpinSet(false);
        if (viewNewAssignmentRequestButton !== null) {
            TriggerListLoadUseEffectSet(assignStatus);
        }
    }, [assignStatus]);

    useEffect(() => {
        if (viewNewAssignmentRequestButton !== null) {
            loadAssignmentList();
        }
    }, [ApplyLocalTimeState]);

    useEffect(() => {
        if (viewNewAssignmentRequestButton !== null) {
            loadAssignmentList();
        }
    }, [viewNewAssignmentRequestButtonSpin, PusherDashboardTrigger]);

    function sortAssignments(data) {
        if (!Array.isArray(data)) return data;
        if (assignStatus === 'upcoming') {
            const nowUnix = dayjs().unix();

            function parseDuration(durationStr) {
                let totalMinutes = 0;
                if (!durationStr) return 0;
                const hrsMatch = durationStr.match(/(\d+)\s*Hrs?/i);
                const minsMatch = durationStr.match(/(\d+)\s*Mins?/i);
                if (hrsMatch) totalMinutes += parseInt(hrsMatch[1], 10) * 60;
                if (minsMatch) totalMinutes += parseInt(minsMatch[1], 10);
                return totalMinutes;
            }

            const futureAssignments = data.filter(item => {
                const startUnix = Number(item.assign_requestdatetime_utc_unix);
                const durationMinutes = parseDuration(item.assign_duration);
                const endUnix = startUnix + durationMinutes * 60;
                return !isNaN(endUnix) && endUnix > nowUnix;
            });

            return futureAssignments.sort((a, b) => {
                const unixA = Number(a.assign_requestdatetime_utc_unix);
                const unixB = Number(b.assign_requestdatetime_utc_unix);
                return unixA - unixB;
            });
        }

        return data;
    }


    function loadAssignmentList() {
        let payload = new FormData();
        payload.append('assign_status', assignStatus);
        payload.append('status', axiosuseEffectstatus);
        payload.append('localtime', ApplyLocalTimeState);
        apiWithAuth.post(url_fetch_assignment_lists, payload, { headers: { "Content-Type": "multipart/form-data" } }).then(response => {
            if (response.data.status) {
                const now = dayjs();
                const hasPast = response.data.data.some(item => {
                    if (!item.assign_requestdatetime) return false;
                    const assignDate = dayjs(item.assign_requestdatetime, 'MM/DD/YYYY hh:mm A');
                    return assignDate.isBefore(now);
                });
                setHasPastAssignments(hasPast);
                const sortedData = sortAssignments(response.data.data);
                newAssignmentRequestArySet(sortedData);
                DisableApplyLocalTimeSet(false);
                if (response.data.data.length === 0) {
                    viewNewAssignmentRequestButtonSet('no_records');
                } else if (response.data.data.length >= 4) {
                    if (axiosuseEffectstatus === "limit") viewNewAssignmentRequestButtonSet('view_all_requests_button');
                    else if (axiosuseEffectstatus === "all") viewNewAssignmentRequestButtonSet('hide_all');
                } else if (response.data.data.length < 4) {
                    viewNewAssignmentRequestButtonSet('hide_all');
                }
            } else if (response.data.status === false && response.data.message === "Token Expired") {
                OpenSwal('Token_error', navigate);
            } else {
                OpenSwal('Axios_error', response.data.message);
            }
        }).catch(response => {
            OpenSwal('Axios_error', response.message);
        });
    }

    const viewAllRequests = () => {
        axiosuseEffectstatuslimitset('all');
        viewNewAssignmentRequestButtonSpinSet(true);
    }
    const TriggerLocalTimeSwitch = (element) => {

        if (element.target.checked) localStorage.setItem('Apply_local_time_state', true);
        else localStorage.removeItem('Apply_local_time_state');
        ApplyLocalTimeStateSet(element.target.checked);
    }

    return (
        <Box>
            <Box sx={{ mb: 6 }}>
                <Grid container>
                    <Grid xs={9} md={9} sm={9}>
                        <Box>
                            <Typography sx={{ typography: { xs: 'subtitle2', sm: 'body1', md: 'h6' } }} color={appThemeColor} style={TextUnderlineHeading}>{assignstatusHeading}</Typography>
                        </Box>
                    </Grid>
                    {/* <Grid xs={3} md={3} sm={3}>
                        <Box sx={{ position: 'relative', mt: -1,width:'100%', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                            <FormControlLabel sx={{ position: 'absolute', top: '-1px', right: hasPastAssignments  && assignStatus === 'upcoming' ? '90px' : '-10px' }} control={<GreenSwitch onChange={TriggerLocalTimeSwitch} checked={ApplyLocalTimeState} disabled={DisableApplyLocalTime} />} label={<Typography variant="caption" sx={{ letterSpacing: '-0.5px', whiteSpace: 'nowrap', position: 'absolute', top: '28px' }} color="#4b4b4c"> Local Time</Typography>} labelPlacement="bottom" />
                            {hasPastAssignments && assignStatus === 'upcoming' && (
                                <LoadingButton
                                    sx={{ ml: 2, color: appThemeColor, textTransform: 'none', fontWeight: 'bold', position: 'absolute', top: '-1px', right: '-10px' }}
                                    onClick={() => navigate('/Interpreter/Lapsed_list')}
                                    variant="outlined"
                                    size="small"
                                >
                                    View Lapsed
                                </LoadingButton>
                            )}
                        </Box>
                    </Grid> */}
                </Grid>
                {viewNewAssignmentRequestButton === null && <Box sx={{ mt: 5, mb: 5, display: 'flex', justifyContent: 'center' }}><LinearProgress color={appThemeSecondaryColor} sx={{ width: '70%', alignItems: 'center' }} /></Box>}

                {/* {viewNewAssignmentRequestButton !== null && <Grid container spacing={{ xs: 1.5, sm: 2, md: 2 }} sx={{ mt: 2 }}>{newAssignmentRequestAry.map((assign_data, index) => {
                    return (<AssignmentsStatusList key={index} cardTheme={cardTheme} appThemeColor={appThemeColor} assign_data={assign_data} assignStatus={assignStatus} />);
                })}</Grid>} */}

{assignStatus === 'invoicing' && (
    <Box
        sx={{
            display: 'flex',
            gap: 1,
            mb: 2,
            mt: 2,
            overflowX: 'auto',
            pb: 0.5
        }}
    >
        {[
            { label: 'Pending', value: 'pending' },
            { label: 'Approved', value: 'approved' },
            { label: 'Paid', value: 'paid' }
        ].map((tab) => {
            const selected = invoiceStatusFilter === tab.value;

            return (
                <Button
                    key={tab.value}
                    variant={selected ? 'contained' : 'outlined'}
                    onClick={() => setInvoiceStatusFilter(tab.value)}
                    sx={{
                        borderRadius: '20px',
                        textTransform: 'none',
                        minWidth: '100px',
                        flexShrink: 0,
                        fontWeight: 600,
                        ...(selected && {
                            backgroundColor: appThemeColor,
                            '&:hover': {
                                backgroundColor: appThemeColor,
                                opacity: 0.9
                            }
                        }),
                        ...(!selected && {
                            color: appThemeColor,
                            borderColor: appThemeColor
                        })
                    }}
                >
                    {tab.label}
                </Button>
            );
        })}
    </Box>
)}
{assignStatus === 'action' && (
    <Box
        sx={{
            display: 'flex',
            gap: 1,
            mb: 2,
            mt: 2,
            overflowX: 'auto',
            pb: 0.5
        }}
    >
        {[
            {
                label: 'Submission',
                value: 'submission'
            },
            {
                label: 'Verification',
                value: 'verification'
            }
        ].map((tab) => {
            const selected = actionListFilter === tab.value;

            return (
                <Button
                    key={tab.value}
                    variant={selected ? 'contained' : 'outlined'}
                    onClick={() => setActionListFilter(tab.value)}
                    sx={{
                        borderRadius: '20px',
                        textTransform: 'none',
                        minWidth: '160px',
                        flexShrink: 0,
                        fontWeight: 600,
                        px: 1.0,
                        py: 0.5,
                        ...(selected
                            ? {
                                backgroundColor: appThemeColor,
                                '&:hover': {
                                    backgroundColor: appThemeColor,
                                    opacity: 0.9
                                }
                            }
                            : {
                                color: appThemeColor,
                                borderColor: appThemeColor
                            })
                    }}
                >
                    {tab.label}
                </Button>
            );
        })}
    </Box>
)}

{viewNewAssignmentRequestButton !== null && (
    <Grid container spacing={{ xs: 1.5, sm: 2, md: 2 }} sx={{ mt: 2 }}>
        {(
            assignStatus === 'invoicing'
                ? newAssignmentRequestAry.filter((invoice) => {
                    const status = String(invoice.invoice_status || '')
                        .toLowerCase();

                    return status === invoiceStatusFilter;
                })
                : assignStatus === 'action'
                    ? newAssignmentRequestAry.filter((item) => {
                        const pageStatus = String(item.page_status || '')
                            .toLowerCase();

                        const actionTag = String(item.action_required_tag || '')
                            .toLowerCase();

                        if (actionListFilter === 'verification') {
                            return (
                                pageStatus === 'verification' ||
                                actionTag === 'verification required'
                            );
                        }

                        return (
                            pageStatus === 'lapsed' ||
                            actionTag === 'submission required'
                        );
                    })
                    : newAssignmentRequestAry
        ).map((assign_data, index) => (
            assignStatus === 'invoicing' ? (
                <InvoiceStatusCard
                    key={assign_data.invoice_pid ?? index}
                    invoice={assign_data}
                    appThemeColor={appThemeColor}
                />
            ) : (
                <AssignmentsStatusList
                    key={index}
                    cardTheme={cardTheme}
                    appThemeColor={appThemeColor}
                    assign_data={assign_data}
                    assignStatus={assignStatus}
                />
            )
        ))}
    </Grid>
)}

                {viewNewAssignmentRequestButton === 'view_all_requests_button' && <Box sx={{ mt: 2, mb: 4 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <LoadingButton sx={{ color: appThemeColor, textTransform: 'none', fontWeight: 'bold' }} onClick={viewAllRequests} loading={viewNewAssignmentRequestButtonSpin} loadingPosition="end" endIcon={<KeyboardDoubleArrowDownIcon />}> Load More </LoadingButton>
                    </Box>
                </Box>}
                {viewNewAssignmentRequestButton === 'no_records' && <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, mb: 5 }}><Typography sx={{ color: appThemeColor }}>No Records Found..!</Typography></Box>}
            </Box>
        </Box>
    );
}

export default AssignmentLists